import CodeView from 'src/components/CodeView';
import defaultTable from 'src/examples/CSS/Table/default';
import stickyHeaderTable from 'src/examples/CSS/Table/stickyHeader';
import stripedTable from 'src/examples/CSS/Table/striped';
import borderedTable from 'src/examples/CSS/Table/bordered';
import hoverableTable from 'src/examples/CSS/Table/hoverable';
import narrowTable from 'src/examples/CSS/Table/narrow';
import smallTable from 'src/examples/CSS/Table/small';
import * as React from 'react';
export default {
  CodeView,
  defaultTable,
  stickyHeaderTable,
  stripedTable,
  borderedTable,
  hoverableTable,
  narrowTable,
  smallTable,
  React
};